// ─── Portal Cliente — Context + Zustand store ────────────────

import React, { createContext, useContext } from 'react';
import { create } from 'zustand';
import { PORTAL_CLIENTE_TOKEN_KEY } from '@api/portal';

interface PortalClienteState {
  token:     string | null;
  clienteId: number | null;
  nombre:    string | null;
  setAuth:   (token: string, clienteId: number, nombre: string) => void;
  clearAuth: () => void;
}

const usePortalClienteStore = create<PortalClienteState>((set) => ({
  token:     localStorage.getItem(PORTAL_CLIENTE_TOKEN_KEY),
  clienteId: null,
  nombre:    null,
  setAuth: (token, clienteId, nombre) => {
    localStorage.setItem(PORTAL_CLIENTE_TOKEN_KEY, token);
    set({ token, clienteId, nombre });
  },
  clearAuth: () => {
    localStorage.removeItem(PORTAL_CLIENTE_TOKEN_KEY);
    set({ token: null, clienteId: null, nombre: null });
  },
}));

const PortalClienteContext = createContext<PortalClienteState | null>(null);

export const PortalClienteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const store = usePortalClienteStore();
  return (
    <PortalClienteContext.Provider value={store}>
      {children}
    </PortalClienteContext.Provider>
  );
};

export const usePortalCliente = (): PortalClienteState => {
  const ctx = useContext(PortalClienteContext);
  if (!ctx) throw new Error('usePortalCliente must be used within PortalClienteProvider');
  return ctx;
};
